import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '@/_metronic/helpers'
import {Brand, BrandsQueryResponse} from './_models'

const BRAND_URL = `/p2c/product/brand`

const getBrands = (query: string): Promise<BrandsQueryResponse> => {
  return axios
    .get(`${BRAND_URL}?${query}`)
    .then((d: AxiosResponse<BrandsQueryResponse>) => {
      return d.data
    })
}

const getBrand = (id: ID): Promise<Brand | undefined> => {
  return axios
    .get(`${BRAND_URL}/${id}`)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const createBrand = (brand: Brand) : Promise<Brand | undefined> => {
  return axios
    .post(BRAND_URL, brand)
    .then((response: AxiosResponse<Response<Brand>>) => response.data)
    .then((response: Response<Brand>) => response.data)
}

const updateBrand = (brand: Brand): Promise<any> => {
  return axios
    .put(BRAND_URL, brand)
    .then((response: AxiosResponse<Response<any>>) => response.data)
}


export {
  getBrands,
  getBrand,
  createBrand,
  updateBrand
}
